import React from 'react';
import CreateTeamForm from '../components/CreateTeamForm';
import PageLayout from '../components/layout/PageLayout';

const CreateTeamPage = () => (
  <PageLayout>
    <CreateTeamForm />
  </PageLayout>
);

export default CreateTeamPage;